import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      console.log("ANTES");
      console.log(params);
      console.log("DESPUES");
      console.log(qs.stringify(params, { encode: false }));
      return qs.stringify(params, { encode: false });
    },
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(`${url}/incidencias?populate=*`, options)
    .then((response) => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta,
      };
    });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(`${url}/incidencias/${id}/details`, options)
    .then((response) => {
      // El nuevo endpoint devuelve los datos directamente en response.data.data
      // Necesitamos normalizar al formato JSON:API que espera el componente
      if (!response.data || !response.data.data) {
        throw new Error('Formato de respuesta inválido del endpoint /details');
      }
      const data = response.data.data;
      
      // Normalizar la estructura para que sea compatible con el formato JSON:API esperado
      const normalized = {
        id: data.id,
        ...data,
        // Normalizar relaciones al formato JSON:API
        estado_incidencia: data.estado_incidencia ? {
          data: {
            id: data.estado_incidencia.id,
            attributes: data.estado_incidencia
          }
        } : null,
        tipo_incidencia: data.tipo_incidencia ? {
          data: {
            id: data.tipo_incidencia.id,
            attributes: data.tipo_incidencia
          }
        } : null,
        usuario: data.usuario ? {
          data: {
            id: data.usuario.id,
            attributes: {
              ...data.usuario,
              imagen_perfil: data.usuario.imagen_perfil ? {
                data: {
                  id: data.usuario.imagen_perfil.id,
                  attributes: {
                    ...data.usuario.imagen_perfil,
                    // Normalizar formats si existe
                    formats: data.usuario.imagen_perfil.formats || null
                  }
                }
              } : null,
              role: data.usuario.role ? {
                data: {
                  id: data.usuario.role.id,
                  attributes: data.usuario.role
                }
              } : null
            }
          }
        } : null,
        activo: data.activo ? {
          data: {
            id: data.activo.id,
            attributes: {
              ...data.activo,
              empresa: data.activo.empresa ? {
                data: {
                  id: data.activo.empresa.id,
                  attributes: data.activo.empresa
                }
              } : null,
              usuario: data.activo.usuario ? {
                data: {
                  id: data.activo.usuario.id,
                  attributes: {
                    ...data.activo.usuario,
                    imagen_perfil: data.activo.usuario.imagen_perfil ? {
                      data: {
                        id: data.activo.usuario.imagen_perfil.id,
                        attributes: data.activo.usuario.imagen_perfil
                      }
                    } : null,
                    role: data.activo.usuario.role ? {
                      data: {
                        id: data.activo.usuario.role.id,
                        attributes: data.activo.usuario.role
                      }
                    } : null
                  }
                }
              } : null,
              modelo: data.activo.modelo ? {
                data: {
                  id: data.activo.modelo.id,
                  attributes: {
                    ...data.activo.modelo,
                    fabricante: data.activo.modelo.fabricante ? {
                      data: {
                        id: data.activo.modelo.fabricante.id,
                        attributes: data.activo.modelo.fabricante
                      }
                    } : null,
                    subtipo: data.activo.modelo.subtipo ? {
                      data: {
                        id: data.activo.modelo.subtipo.id,
                        attributes: data.activo.modelo.subtipo
                      }
                    } : null,
                    imagen: data.activo.modelo.imagen ? {
                      data: {
                        id: data.activo.modelo.imagen.id,
                        attributes: data.activo.modelo.imagen
                      }
                    } : null
                  }
                }
              } : null,
              fabricante: data.activo.fabricante ? {
                data: {
                  id: data.activo.fabricante.id,
                  attributes: data.activo.fabricante
                }
              } : null,
              division: data.activo.division ? {
                data: {
                  id: data.activo.division.id,
                  attributes: data.activo.division
                }
              } : null,
              tipo: data.activo.tipo ? {
                data: {
                  id: data.activo.tipo.id,
                  attributes: data.activo.tipo
                }
              } : null,
              subtipo: data.activo.subtipo ? {
                data: {
                  id: data.activo.subtipo.id,
                  attributes: data.activo.subtipo
                }
              } : null
            }
          }
        } : null,
        incidence_documents: data.incidence_documents ? {
          data: Array.isArray(data.incidence_documents) 
            ? data.incidence_documents.map(doc => ({
                id: doc.id,
                attributes: doc
              }))
            : [{
                id: data.incidence_documents.id,
                attributes: data.incidence_documents
              }]
        } : { data: null }
      };
      
      return normalized;
    });
}

function add(incidencia) {
  console.log(incidencia);
  var payload = { data: incidencia };

  console.log(payload);

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.post(`${url}/incidencias`, payload, options).then((response) => {
    return jsona.deserialize(response.data);
  });
}

function update(incidencia) {
  console.log(incidencia);
  var payload = { data: incidencia };

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .put(`${url}/incidencias/${incidencia.id}`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/incidencias/${id}`, options);
}

export default {
  list,
  get,
  add,
  update,
  destroy,
};
